// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, isAdmin } = useAuth();

  // 로그인 안 한 사용자는 로그인 페이지로
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // adminOnly 페이지에 일반 사용자가 접근하면 홈으로
  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  // 조건 모두 통과하면 자식 컴포넌트 렌더링
  return children;
}
